export enum APICallContextEnum {
  DASHBOARD = 'DASHBOARD',
  DASHBOARD_EDIT = 'DASHBOARD_EDIT',
  FINDING_LIST = 'FINDING_LIST',
  BLANK = 'BLANK',
  // ENG-137551 — new page source values
  FINDING_DETAILS = 'FINDING_DETAILS',
  PRODUCT_LIST = 'PRODUCT_LIST',
  SUBPRODUCT_LIST = 'SUBPRODUCT_LIST',
  TICKET_LIST = 'TICKET_LIST',
  ONBOARDING = 'ONBOARDING',
  HIERARCHIES = 'HIERARCHIES',
  ENGAGEMENT_DETAILS = 'ENGAGEMENT_DETAILS',
  ASSET_DETAILS = 'ASSET_DETAILS',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  HIERARCHY_DETAILS = 'HIERARCHY_DETAILS',
}
